import DeviseLogin from '../../views/devise/login.vue';

document.addEventListener('DOMContentLoaded', () => {
  var element = document.getElementById('vue')
  if (element != null) {
    var app = new Vue({
      el: element,
      components: {
        'devise-login': DeviseLogin
      }
    })
  }
});
